<template>

</template>

<script>
export default {
name: "tab_user"
}
</script>

<style scoped>

</style>